import { Box } from '@mui/material';
import AnimatedSkeleton from '@/TRC/components/PdfView/components/AnimatedSkeleton';
import PdfPageCanvas from '@/TRC/components/PdfView/components/PdfPageCanvas';

const PdfSpread = ({
	gap,
	w,
	h,
	showRightPage,
	leftCanvasRef,
	rightCanvasRef,
	docLoading,
	rendering,
	leftPageLinks,
	rightPageLinks,
	onPdfLinkClick
}) => {
	return (
		<Box
			sx={{
				display: 'flex',
				gap: `${gap / 16}rem`,
				justifyContent: 'center',
				alignItems: 'center',
				overflow: 'hidden'
			}}
		>
			{/* LEFT */}
			<Box sx={{ position: 'relative' }}>
				<PdfPageCanvas
					canvasRef={leftCanvasRef}
					width={w}
					height={h}
					showSkeleton={docLoading}
					linkOverlays={leftPageLinks}
					onPdfLinkClick={onPdfLinkClick}
				/>
				{!docLoading && rendering && (
					<AnimatedSkeleton
						variant="rectangular"
						sx={{ position: 'absolute', inset: 0, opacity: 0.6, pointerEvents: 'none' }}
						width={w}
						height={h}
					/>
				)}
			</Box>

			{/* RIGHT */}
			{showRightPage && (
				<Box sx={{ position: 'relative' }}>
					<PdfPageCanvas
						canvasRef={rightCanvasRef}
						width={w}
						height={h}
						showSkeleton={docLoading}
						linkOverlays={rightPageLinks}
						onPdfLinkClick={onPdfLinkClick}
					/>
					{!docLoading && rendering && (
						<AnimatedSkeleton
							variant="rectangular"
							sx={{ position: 'absolute', inset: 0, opacity: 0.6, pointerEvents: 'none' }}
							width={w}
							height={h}
						/>
					)}
				</Box>
			)}
		</Box>
	);
};

export default PdfSpread;
